import './Banner.sass'
import icon from '../../assets/img/banner/image.png'

export default function Banner() {
    return (
        <section className="section-banner">
            <div className="container">
                <div className="banner">
                    <h2 className="banner-title">
                        Шоурум Danogips
                    </h2>
                    <div className="banner-content">
                        <button className="banner-button">Обучение</button>
                        <button className="banner-button">Общение</button>
                        <button className="banner-button">Обмен опытом</button>
                    </div>
                    <div className="banner-info">
                        <img src={icon} alt="image" className="banner-info__img" />
                        <div className="banner-info__block">
                            <strong className="banner-info__title">Скоро открытие!</strong>
                            <p className="banner-info__text">г. Санкт-Петербург, ул. Салова, 45 лит. Ф</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}